import React from 'react'

import { PageLayout } from 'apps/aiAutomation/layout/PageLayout'
import { Ability } from 'common/core/constants/Ability'
import { useAbility } from 'common/core/hooks/useAbility'
import { LayoutWithSidebar } from 'utils/router/components/LayoutWithSidebar/LayoutWithSidebar'

export const AiAutomationRouter = () => {
  const aiAlwaysOnAbility = useAbility(Ability.AI_ALWAYS_ON)

  const isNavigationAvailable = aiAlwaysOnAbility.isEnabled

  if (isNavigationAvailable) {
    return <LayoutWithSidebar contentLayout={PageLayout} />
  }

  return <LayoutWithSidebar />
}
